import * as React from "react";
import type { Theme } from "../../theme";

const css = ({ gridUnit, colors }: Theme) => ({
  width: gridUnit * 2.5,
  height: gridUnit * 2.5,
  borderRadius: "100%",
  marginBottom: gridUnit,
  backgroundColor: colors.activeGreen
});
export const ActiveMarker = (): React.ReactNode => <div css={css} />;
export default ActiveMarker;
